export const initialState = {
  username: '',
  firstName: '',
  lastName: '',
  email: '',
  selectedStatus: '',
  searchDate: []
};
